"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TooltipOverflowMode;
(function (TooltipOverflowMode) {
    /** Only show tooltip if parent DOM element is overflowing */
    TooltipOverflowMode[TooltipOverflowMode["Parent"] = 0] = "Parent";
    /** Only show tooltip if tooltip host's content is overflowing */
    TooltipOverflowMode[TooltipOverflowMode["Self"] = 1] = "Self";
})(TooltipOverflowMode = exports.TooltipOverflowMode || (exports.TooltipOverflowMode = {}));
//# sourceMappingURL=TooltipHost.Props.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Tooltip/TooltipHost.Props.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Tooltip/TooltipHost.Props.js
// module chunks = 1